import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { environment } from '@ib-env/environment';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';

import { SIGN_UP_FIELDS } from '../../../enums/sign-up-fields.enum';
import { SignUpFacadeService } from '../../../services/sign-up-facade.service';
import { SignUpFormHelperService } from '../../../services/sign-up-form-facade.service';

@Component({
  selector: 'ib-sign-up-step-finish',
  templateUrl: './sign-up-step-finish.component.html',
  styleUrls: ['./sign-up-step-finish.component.scss'],
})
export class SignUpStepFinishComponent
  extends AbstractBaseComponent
  implements OnInit
{
  @Input() form: FormGroup;
  public readonly SIGN_UP_FIELDS = SIGN_UP_FIELDS;

  constructor(
    public formS: SignUpFormHelperService,
    private facadeS: SignUpFacadeService,
  ) {
    super();
  }
  ngOnInit(): void {
    this.initFormFields();
  }

  initFormFields(): void {
    // mocks
    if (!environment.production && environment.allowSignUpUseMocks) {
      this.form.get(this.SIGN_UP_FIELDS.ACCOUNT_BANK_CURRENCY).setValue('gbp');
      this.form
        .get(this.SIGN_UP_FIELDS.ACCOUNT_HOLDER_NAME)
        .setValue('denis ost');
      // UA 62 322001 00000 2600 1300 0333 28
      this.form
        .get(this.SIGN_UP_FIELDS.ACCOUNT_IBAN)
        .setValue('GB29NWBK60161331926819');
    }
  }

  submitFromInput(e): void {
    e.stopPropagation();
    e.preventDefault();
    if (this.form.valid) {
      this.facadeS.finish();
    } else {
      this.form.markAllAsTouched();
    }
  }
}
